import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsTrafficLightsComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get selected(): boolean {
		return !!this.block.showTrafficLights;
	}

	@action
	changeSelected(selected: boolean): void {
		this.block.showTrafficLights = selected;
		this.blockSetup.trackBlockPropertySettingsChangeEvent({ show_traffic_lights: selected });
		this.blockSetup.saveBlock();
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showTrafficLights"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>
				Use traffic light colors
				<ToolTipWithIconComponent
					@text="Progress is shown in red, green or amber depending on completion level."
					@maxWidth={{260}}
				/>
			</label>
		</div>
	</template>
}
